import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Container, Row, Col } from "react-bootstrap"
import Title from "../common/title"
import { useIntl } from "gatsby-plugin-react-intl"
import Slider from "react-slick"

const BlockInclusive = ({ info }) => {

  const settings = {
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "20px",
        },
      },
    ],
  }

  return (
    <section className="blk-slider-inclus">
      <Container>
        <Row>
          <Col md={12}>
            {info.title && (
              <Title heading={3} text={info.title} />
            )}
            <Slider {...settings} className="blkSlider">
              {info.relationships.items.map((list, index) => {
                return (
                  <div key={index}>
                    <GatsbyImage
                      image={getImage(list.relationships?.image?.relationships?.field_image.gatsbyImage)}
                    />
                    {list.included_item_title && (
                      <h3>{list.included_item_title}</h3>
                    )}
                  </div>
                )
              })}
            </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment infoInclusive on paragraph__whats_included {
    internal {
      type
    }
    title
    relationships {
      items {
        included_item_title
        relationships {
          image {
            relationships {
              ...getImage
            }
            field_image {
              alt
            }
          }
        }
      }
    }
  }
`

export default BlockInclusive
